module.exports = __webpack_public_path__ + "static/media/HighFive_Logo_Swoosh_LeftAligned.192a24a8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/HighFive_Logo_Swoosh_LeftAligned.svg
// module id = 276
// module chunks = 0